import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, testId }) => {
  const MTag = motion.h1;
  return (
    <MTag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.1, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MTag>
  );
};

export const SectionHeader = ({ index, overline, title, dark = false, className = "" }) => (
  <div className={className}>
    <Reveal>
      <div className="flex items-center gap-4">
        {index && (
          <span className="font-heading text-xs font-bold tracking-[0.25em] text-gold">
            {index}
          </span>
        )}
        <span className="h-px w-10 bg-gold" />
        <span
          className={`text-xs font-medium uppercase tracking-[0.25em] ${
            dark ? "text-white/60" : "text-charcoal/60"
          }`}
        >
          {overline}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-6 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl text-balance ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);
